import com.soywiz.korge.*
import com.soywiz.korge.scene.*
import com.soywiz.korgw.*
import com.soywiz.korinject.*
import com.soywiz.korma.geom.*
import i18n.*
import scenes.*
import utils.*
import ysdk.*
import kotlin.reflect.*

suspend fun main() {
    println("FantasyRun is starting")
    val yaSdk = getYaSdk()
    if (yaSdk != null) {
        println("YaSdk initialized")

        AppIntegrations.yaSdk = yaSdk
        Localization.CURRENT_LOCALE = yaSdk.environment.i18n.lang

        printJson(yaSdk)
    }

    Localization.loadResources()

    Korge(
        Korge.Config(
            title = "FantasyRun",
            quality = GameWindow.Quality.AUTOMATIC,
            module = MyModule(AppState()),
            virtualSize = SizeInt(GameDimensions.V_WIDTH, GameDimensions.V_HEIGHT),
        )
    )
}

class AppState {
    var nextLevel = -1
    var sceneToLoad: KClass<out Scene>? = null
}

object AppIntegrations {
    var yaSdk: YaSdk? = null
}

class MyModule(
    private val appState: AppState
) : Module() {
    override val mainScene: KClass<out Scene> = MainMenuScene::class

    override suspend fun AsyncInjector.configure() {
        mapSingleton { appState }

        configureGameScenes()
        configureTestScenes()
    }
}
